import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
export default function materialityReducer(state = initialState.materiality, action) {
	switch (action.type) {
		case types.GET_MATERIALITY: {
			if (action.response) {
				let materiality = {
					currentPeriod: [],
					priorPeriod: []
				}
				materiality.currentPeriod = action.response.find((materiality) => materiality.isCurrent && !materiality.isPriorYear)
				materiality.priorPeriod = action.response.find((materiality) => materiality.isCurrent && materiality.isPriorYear)
				return materiality;
			}
			return state;
		}
		default:
			return state;
	}
}